import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/legal/LegalLayout.tsx");
